<template>
  <div
    v-if="!!gallery"
    class="d-flex flex-wrap flex-sm-nowrap align-sm-center justify-space-between"
  >
    <button
      :disabled="gallery.length <= 1 || fullscreen"
      @click="prevImage"
      type="button"
      class="pr-4 grow order-1 order-sm-0"
    >
      <iconPrevious class="icon prev" />
    </button>
    <div
      :class="{
        'gallery-fullscreen': fullscreen,
        'my-sm-0': !fullscreen
      }"
      class="gallery shrink order-0 order-sm-1"
    >
      <transition name="fade" mode="out-in">
        <Gallery360
          v-if="gallery[currentImage].is360"
          :content="gallery[currentImage]"
          :sku="sku"
        />
        <v-img
          v-else
          @click="onToogleFullscreen"
          :key="gallery[currentImage].id"
          :src="'/media/' + gallery[currentImage].id"
          :aspect-ratio="1"
          transition="fade"
          class="image"
          contain
        />
      </transition>
      <img v-if="!fullscreen && isPremium" :src="IconUnicum" class="unicum">
    </div>
    <button
      :disabled="gallery.length <= 1 || fullscreen"
      @click="nextImage"
      type="button"
      class="pl-4 grow order-2 order-sm-2"
    >
      <iconNext class="icon next" />
    </button>
  </div>
</template>

<script>
import iconPrevious from '@/assets/svg/icon-previous.svg'
import iconNext from '@/assets/svg/icon-next.svg'
import IconUnicum from '@/assets/img/unicum-icon-overlay.png'
import Gallery360 from '@/molecules/Gallery360'

export default {
  name: 'Gallery',
  props: {
    sku: {
      type: String
    },
    collection: {
      type: Array,
      default: null
    },
    content360: {
      type: Object
    },
    isPremium: {
      type: Boolean,
      default: false
    }
  },
  components: {
    iconPrevious,
    iconNext,
    Gallery360
  },
  data () {
    return {
      gallery: null,
      IconUnicum,
      currentImage: 0,
      fullscreen: false
    }
  },
  mounted () {
    if (this.content360) {
      this.gallery = [...this.collection, { is360: true, ...this.content360 }]
    } else {
      this.gallery = this.collection
    }
  },
  methods: {
    onToogleFullscreen () {
      this.fullscreen = !this.fullscreen
      this.$events.emit('onGalleryFullscreen', this.fullscreen)
      if (this.fullscreen) this.$events.emit('onHideLogo')
      else this.$events.emit('onShowLogo')
    },
    prevImage () {
      this.currentImage = this.currentImage - 1 < 0 ? this.gallery.length - 1 : this.currentImage - 1
      this.$emit('change-slide', this.currentImage)
    },
    nextImage () {
      this.currentImage = this.currentImage + 1 >= this.gallery.length ? 0 : this.currentImage + 1
      this.$emit('change-slide', this.currentImage)
    }
  }
}
</script>

<style lang="scss" scoped>
/* stylelint-disable */
.gallery {
  width: 100%;
  height: 100%;
  max-width: 75vh;
  cursor: zoom-in;
  position: relative;

  @include breakpoint ('sm-only') {
    max-width: 500px;
    margin: auto;
  }

  @include breakpoint ('xs-only') {
    max-width: 350px;
    margin: auto;
    margin-bottom: 20px;
  }

  &.gallery-fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 22;
    width: 100%;
    max-width: 100%;
    height: 100vh;
    max-height: 100%;
    cursor: zoom-out;

    .image {
      width: 100% !important;
      height: 100% !important;
    }
  }

  .image {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;

    @include breakpoint('xs-only') {
      width: 80vw;
      height: 80vw;
    }

    ::v-deep .v-image__image {
      transition: transform 0.4s $ease-in-out-quad;
    }

    &:hover ::v-deep .v-image__image {
      transform: scale(1.05);
    }
  }
}

.unicum {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  width: 100px;
  height: 100px;

  @include breakpoint ('sm-only') {
    width: 85px;
    height: 85px;
    transform: translate(50%, -50%);
  }

  @include breakpoint ('xs-only') {
    width: 70px;
    height: 70px;
    transform: translate(30%, -30%);
  }
}

button {
  outline: none;
  opacity: 0.8;
  z-index: 100;

  .icon {
    width: 48px;
    height: 48px;
  }

  &:not(:disabled) {
    transition: transform 0.4s $ease-in-out-quad;
  }

  &:hover {
    opacity: 1;

    svg.prev path {
      @include breakpoint ('md-and-up') {
        animation: onHoverLeft 0.4s ease-in-out;
      }
    }

    svg.next path {
      @include breakpoint ('md-and-up') {
        animation: onHoverRight 0.4s ease-in-out;
      }
    }
  }

  &:disabled {
    pointer-events: none;
    opacity: 0 !important;

    @include breakpoint ('sm-and-down') {
      display: none;
    }
  }
}
/* stylelint-enable */

@keyframes onHoverLeft {
  0% {
    transform: translate3d(0%, 0%, 0);
    opacity: 1;
  }

  33% {
    transform: translate3d(-50%, 0%, 0);
    opacity: 0;
  }

  34% {
    transform: translate3d(50%, 0, 0);
    opacity: 0;
  }

  100% {
    transform: translate3d(0%, 0%, 0);
    opacity: 1;
  }
}

@keyframes onHoverRight {
  0% {
    transform: translate3d(0%, 0%, 0);
    opacity: 1;
  }

  33% {
    transform: translate3d(50%, 0%, 0);
    opacity: 0;
  }

  34% {
    transform: translate3d(-50%, 0, 0);
    opacity: 0;
  }

  100% {
    transform: translate3d(0%, 0%, 0);
    opacity: 1;
  }
}
</style>
